import React, { Component, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Information from  '@/components/elements/global/Information';




const InformationPortal = () => {

    const [text, setText] = useState<string>('');
    const [style, setStyle] = useState<any>({});

    const [targetContainer, setTargetContainer] = useState<any>(undefined);

    useEffect(() => {
        // expose a function to refresh the portal - incase anything changes
        ;(window as any).renderInformationPortal = () => setTargetContainer(document.getElementById('react-information-container'));
    },[])

    
    useEffect(() => {
        if (targetContainer) {
            setText(targetContainer.getAttribute('data-text'));
            setStyle(JSON.parse(targetContainer.getAttribute('data-style')));
        }
    }, [targetContainer])

    if(!targetContainer) {
        return null;
    }

    return ReactDOM.createPortal(
      <Information text={text} style={style}/>, targetContainer
    );
}


export default InformationPortal;